<!-- 会员升级礼基本信息表单 -->
<template>
  <div>
    <div class="newsInfo">基本信息</div>
    <el-form-item label="活动名称:" required>
      <el-input v-model="formData.activityName" :disabled="backgroundOpacity" maxlength="15" show-word-limit
        placeholder="请输入活动名称" style="width: 400px"></el-input>
    </el-form-item>
    <el-form-item label="活动时间:" required>
      <div class="my_select_time">
        <el-date-picker prefix-icon="no_icon" v-model="activityStartTime" type="datetime" placeholder="开始日期"
          size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 185px; font-size: 12px" class="time1" @change="activityTimeChange"
          :picker-options="pickerOptionsValue" :default-time="this.$getDate(30)[0].substring(
            11,
            this.$getDate(30)[0].length
          )
            " :clearable="false" :disabled="isDisabled">
        </el-date-picker>
        <div class="time_to_text">至</div>
        <el-date-picker prefix-icon="no_icon" v-model="activityEndTime" type="datetime" placeholder="结束日期" size="small"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px; font-size: 12px"
          class="time2" @change="activityTimeChange" @focus="orderFocus" :picker-options="pickerOptionsValueEnd"
          :default-time="this.$getDate(30)[0].substring(
            11,
            this.$getDate(30)[0].length
          )
            " :clearable="false" :disabled="backgroundOpacity">
        </el-date-picker>
        <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart && !backgroundOpacity"
          @click="clearTime()"></i>
        <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
      </div>
      <span class="lastTime" style="color: #666">
        活动持续 <span style="color: #2768ff">{{ timeDay }}</span> 天
        <span style="color: #2768ff">{{ timeOut }}</span> 小时
        <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
          <el-button type="text" style="width: 35px">
            <i class="el-icon-question"></i>
          </el-button>
        </el-tooltip>
      </span>
      <div v-if="isShowTip" style="color: #ff0000;">
        *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
      </div>
    </el-form-item>

    <el-form-item label="活动对象:" prop="partner">
      <el-radio v-model="actMember" label="1" :disabled="isDisabled">不限</el-radio>
      <el-radio v-model="actMember" label="2" :disabled="isDisabled">会员身份</el-radio>
      <!-- 京获客无法选择人群 -->
      <el-radio v-model="actMember" label="3" :disabled="true">指定人群<el-button style="margin-left: 10px"
          v-if="actMember == '3'" :disabled="true" @click="openCrowd">已选人群({{ peopleSelected.length
          }})</el-button></el-radio>

      <!-- 会员身份选择 -->
      <div v-if="actMember == '2'" style="display: flex">
        <span>会员等级：</span>
        <el-checkbox-group v-model="formData.partner" @change="checkListchange" :disabled="isDisabled"
          v-if="actMember == '2'">
          <el-checkbox label="-1" name="partner">全部</el-checkbox>
          <el-checkbox label="0" name="partner">非会员</el-checkbox>
          <el-checkbox v-for="(item, index) in levelList" :key="index" :label="index + 1 + ''" name="partner">{{
            item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div v-if="actMember == '2'" style="display: flex">
        <span>入会时间：</span>
        <el-checkbox v-model="ruleDto.isCheckOpenCardTime" :disabled="isDisabled">指定时间段</el-checkbox>
        <div class="my_select_time" style="margin-left: 8px">
          <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime" placeholder="开始日期"
            size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 185px; font-size: 12px" class="time1" :clearable="false"
            :disabled="!ruleDto.isCheckOpenCardTime || isDisabled">
          </el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime" placeholder="结束日期"
            size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px; font-size: 12px" class="time2" :picker-options="openCardEndTimeOptionsValue"
            :clearable="false" :disabled="!ruleDto.isCheckOpenCardTime || isDisabled">
          </el-date-picker>
          <i v-if="!activityData.isStart" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
          <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
        </div>
      </div>
      <span v-if="actMember == '2'" style="color: #f56c6c">注意：该条件对【非会员】身份不生效</span>
    </el-form-item>

    <!-- Plus会员限制 -->
    <el-form-item label="Plus会员身份:" required>
      <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="isDisabled">不限</el-radio>
      <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="isDisabled">Plus会员</el-radio>
      <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="isDisabled">非plus会员</el-radio>
      <div style="color:#F56C6C">注意：使用该判断需满足"与京东PLUS团队有合作关系的商家"及"京东PLUS团队准许调用本接口的商家"，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
      </div>
    </el-form-item>
    <el-form-item label="活动条件:">
      <el-checkbox label="关注店铺后方可参与活动" v-model="formData.condFollow" :disabled="isDisabled2"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'BasicInfoForm',
  props: {
    // 表单数据
    value: {
      type: Object,
      required: true
    },
    // 活动数据
    activityData: {
      type: Object,
      default: () => ({
        isStart: false
      })
    },
    // 背景透明度控制（禁用状态）
    backgroundOpacity: {
      type: Boolean,
      default: false
    },
    // 会员等级列表
    levelList: {
      type: Array,
      default: () => []
    },
    // 已选人群
    peopleSelected: {
      type: Array,
      default: () => []
    },
    // 规则数据
    ruleDto: {
      type: Object,
      default: () => ({
        isCheckOpenCardTime: false,
        openCardStartTime: '',
        openCardEndTime: '',
        plusObject: 0
      })
    },
    // 开始时间
    startTime: {
      type: String,
      default: ''
    },
    // 结束时间
    endTime: {
      type: String,
      default: ''
    },
    objectType: ''
  },
  watch: {
    value: {
      handler(val) {
        this.formData = val;
        console.log("--- this.formData:---", this.formData)
      },
      deep: true
    },
    startTime: { // 给活动开始时间设置默认值
      handler(val) {
        if (val) {
          this.activityStartTime = val;
          this.calculateDuration(); // 计算活动持续时间
        }
      },
      immediate: true
    },
    endTime: { // 给活动结束时间设置默认值
      handler(val) {
        if (val) {
          this.activityEndTime = val;
          this.calculateDuration(); // 计算活动持续时间
        }
      },
      immediate: true
    },
    formData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
    actMember: {
      handler(val) {
        this.$emit('changeActMember', val);
      }
    },
    objectType: {
      handler(val) {
        this.actMember = val;
      }
    }
  },
  data() {
    return {
      formData: this.value,
      actMember: '1', // 活动对象
      activityStartTime: '', // 活动开始时间
      activityEndTime: '',// 活动结束时间
      timeDay: 0, // 活动持续天数
      timeOut: 0, // 活动持续小时数
      isShowTip: false, // 是否显示提示
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.activityStartTime) {
            return time.getTime() < new Date(this.activityStartTime).getTime();
          }
        }
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleDto.openCardStartTime) {
            return time.getTime() < new Date(this.ruleDto.openCardStartTime).getTime();
          }
        }
      }
    };
  },
  computed: {
    isDisabled() { // 活动开始或查看状态后不可修改
      return this.activityData.isStart || this.backgroundOpacity;
    },
    isDisabled2() { // 查看状态不可修改
      return this.backgroundOpacity;
    }
  },
  methods: {
    // 计算活动持续时间
    calculateDuration() {
      if (this.activityStartTime && this.activityEndTime) {
        const startTime = new Date(this.activityStartTime).getTime();
        const endTime = new Date(this.activityEndTime).getTime();
        const diffTime = endTime - startTime;
        this.timeDay = Math.floor(diffTime / (24 * 60 * 60 * 1000));
        this.timeOut = Math.floor((diffTime % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      }
    },
    // 活动时间变更
    activityTimeChange() {
      this.calculateDuration();
      this.$emit('activity-time-change', {
        startTime: this.activityStartTime,
        endTime: this.activityEndTime
      });
    },
    // 清除时间
    clearTime() {
      this.activityStartTime = '';
      this.activityEndTime = '';
      this.timeDay = 0;
      this.timeOut = 0;
      this.$emit('clear-time');
    },
    // 清除入会时间
    clearNewTime() {
      this.ruleDto.openCardStartTime = '';
      this.ruleDto.openCardEndTime = '';
      this.$emit('clear-new-time');
    },
    // 订单焦点
    orderFocus() {
      // 实现订单焦点逻辑
      if(this.activityData.isStart){
        this.isShowTip = true;
      }
    },
    // 复选框变更
    checkListchange(val) {
      this.$emit('check-list-change', val);
    },
    // 打开人群选择
    openCrowd() {
      this.$emit('open-crowd');
    }
  }
}
</script>

<style scoped></style>